import React, { memo } from "react";
import { Typography } from "@mui/material";
import { TypographyColor } from "../types";
import "./styles.scss";

export interface TypographyComponentProps {
  children: React.ReactNode;
  variant?: any;
  component?: any;
  className?: string;
  color?: TypographyColor;
}

export const TypographyComponent: React.FC<TypographyComponentProps> = ({
  children,
  variant,
  component,
  className,
  color,
  ...otherProps
}: TypographyComponentProps) => {
  return (
    <Typography
      variant={variant}
      component={component}
      className={className}
      color={color}
    >
      {children}
    </Typography>
  );
};

export default memo(TypographyComponent);
